<template>
    <div class="giftcard" v-if="readMode" :class="{'giftcard-readmode': appliedGiftcards.length > 0}">
        <div class="giftcard-content" v-if="appliedGiftcards.length > 0 && !isb2b">
            <div class="giftcard-row">
                <span class="giftcard-title">{{ iHaveGiftcardText }}</span>
            </div>
        </div>

        <div class="applied-giftcards-container" v-for="(appliedGiftcard, index) in appliedGiftcards" :key="appliedGiftcard.id" :value="appliedGiftcard">
            <div class="applied-giftcard">
                <div class="giftcard-details">
                    <span class="icon ico " :class="'pay-' + appliedGiftcard.brand + '-small'"></span>
                    <div class="giftcard-details-text">
                        <div class="details-row">
                            <span class="gift-card-name">{{appliedGiftcard.name}}</span>
                            <span>{{appliedGiftcard.amount}}</span>
                        </div>
                        <span class="amount-left" v-if="appliedGiftcard.amountLeft">{{appliedGiftcard.amountLeft + ' ' + resources.giftcards.amountRemainingOnThisCard}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="giftcard" v-else>
        <div v-if="!isb2b" class="giftcard-content">
            <div class="giftcard-row">
                <span class="giftcard-title">{{ iHaveGiftcardText }}</span>
                <button type="button" class="giftcard-button" v-if="!giftcardOptionsField.state.value" @click="displayGiftcardForm(true)">
                    <span v-if="appliedGiftcards.length == 0" class="giftcard-text">{{ resources.giftcards.add }}</span>
                    <span v-if="appliedGiftcards.length > 0" class="giftcard-text">{{ resources.giftcards.addanother }}</span>
                    <span class="giftcard-icon"></span>
                </button>
            </div>
            <div v-show="giftcardOptionsField.state.value" class="giftcard-details-form vue-form">
                <div class="vue-form-row" v-if="hasMoreGiftCardOption">
                    <vue-input
                        :element="giftcardOptionsField"
                            tabindex=""
                            @blur="updateSelectedGiftcard(giftcardOptionsField.id, $event.target.value)">
                    </vue-input>
                </div>

                <div class="giftcard-message" v-if="!isGiftCardSelected">
                    <span>{{resources.giftcards.nonSelectedGiftcardMessage}}</span>
                </div>

                <div class="giftcard-form" v-if="isGiftCardSelected">
                    <GiftCard :giftCardType=this.giftCardType v-on:cancelEditing="displayGiftcardForm(false)" v-on:cardAdded="cardAdded"/>
                </div>
            </div>
        </div>

        <div class="applied-giftcards-container" v-for="(appliedGiftcard, index) in appliedGiftcards" :key="appliedGiftcard.id" :value="appliedGiftcard">
            <div class="applied-giftcard">
                <div class="giftcard-details">
                    <span class="icon ico " :class="'pay-' + appliedGiftcard.brand + '-small'"></span>
                    <div class="giftcard-details-text">
                        <div class="details-row">
                            <span class="gift-card-name">{{appliedGiftcard.name}}</span>
                            <span>{{appliedGiftcard.amount}}</span>
                        </div>
                        <span class="amount-left" v-if="appliedGiftcard.amountLeft">{{appliedGiftcard.amountLeft + ' ' + resources.giftcards.amountRemainingOnThisCard}}</span>
                    </div>
                </div>
                <button class="button-remove" @click="removeGiftcard(index, appliedGiftcard)">{{resources.remove}}</button>
            </div>
        </div>

        <div class="inline-alert error" v-if="limitationForGiftCard">
            <span>{{resources.giftcards.limitError}}</span>
        </div>

        <div class="inline-alert error" v-if="needMorePaymentInstruments">
            <span>{{resources.giftcards.completeTheRemainingAmount}}</span>
        </div>

        <div class="inline-alert error" v-if="showRemovalMessage">
            <span>{{resources.giftcards.removedGiftCard}}</span>
        </div>

        <div class="inline-alert error" v-if="hideKlarnaOverTime">
            <span>{{resources.giftcards.cantPayWithKlarna}}</span>
        </div>

        <div v-if="payingFullAmountWithGiftcard">
            <div class="inline-alert confirmation">
                <span>{{resources.giftcards.noAdditionalPaymentNeeded}}</span>
            </div>
        </div>
    </div>
</template>

<script src='./giftcard-block.js'></script>
